import { Breakpoint } from './breakpoint.ts';
import { FontWeight } from './font-weight.ts';
import { Size } from './size.ts';
import { FontSize } from './fontSize.ts';
import { Constant } from './constant.ts';
import { Border } from './Border.ts';
import { Color } from './color.ts';

/**
 * Represents the application theme configuration. Consists of various
 * properties that define the design and visual consistency across the app.
 * Each property provides specific configurations for breakpoints, colors,
 * constants, font weights, sizes, font sizes, and overall theme settings.
 *
 * Properties:
 * - `Breakpoint`: Contains definitions for responsive design breakpoints.
 * - `BorderRadius`: Contains definitions for border radius.
 * - `Constant`: Stores constant values used throughout the theme.
 * - `FontWeight`: Defines various font weight options for text styling.
 * - `Size`: Represents sizing configurations for components and layout.
 * - `FontSize`: Contains the configuration for font size scales.
 */
export const AppTheme = {
  Breakpoint: Breakpoint,
  Border: Border,
  Constant: Constant,
  FontWeight: FontWeight,
  Size: Size,
  Color: Color,
  FontSize: FontSize,
};
